/* Created by Interactive 63 - https://interactive63.com */
/**
 * A small bounded cache for derived easing data, so repeated evaluation of the same easing
 * does not rebuild curves or point lists.
 */

export class BoundedCache<V> {
  private readonly entries = new Map<string, V>();

  /** Creates a cache that holds at most `limit` entries, discarding the oldest first. */
  constructor(private readonly limit: number) {}

  /** Returns the cached value for a key, creating and storing it on a miss. */
  get(key: string, create: () => V): V {
    const hit = this.entries.get(key);
    if (hit !== undefined) return hit;
    const value = create();
    if (this.entries.size >= this.limit) {
      const oldest = this.entries.keys().next();
      if (!oldest.done) this.entries.delete(oldest.value);
    }
    this.entries.set(key, value);
    return value;
  }

  /** Number of entries currently held. */
  get size(): number {
    return this.entries.size;
  }
}
